import createIcon from '../../createIcon';

/**
 * @component @name HourglassFull
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAyVjhINi4wMUw2IDguMDFMMTAgMTJMNiAxNkw2LjAxIDE2LjAxSDZWMjJIMThWMTYuMDFIMTcuOTlMMTggMTZMMTQgMTJMMTggOC4wMUwxNy45OSA4SDE4VjJINloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HourglassFull = createIcon('HourglassFull', [
  [
    'path',
    {
      d: 'M6 2V8H6.01L6 8.01L10 12L6 16L6.01 16.01H6V22H18V16.01H17.99L18 16L14 12L18 8.01L17.99 8H18V2H6Z',
      key: 'j7o5c1',
    },
  ],
]);

export default HourglassFull;
